export default __webpack_public_path__ + "bml-characteristic2.1816923.png";